module.exports = __webpack_public_path__ + "img/icon-document-inactive.a517afe6.png";